import React from 'react';
import { Fade } from '@material-ui/core';
import { isSuccessState } from 'globals/utils';
import reportLocales from 'globals/locales/report';
import FsPaper from 'ui-elements/main-elements/FsPaper';
import FsDefaultFallbackComponent from 'ui-elements/loaders/FsDefaultFallbackComponent';
import { useReportContext } from 'contexts/report/ReportContext';
import { observer } from 'mobx-react';
import FsMinWidthScrollBox from 'ui-elements/boxes/FsMinWidthScrollBox';
import {
  Caption,
  DataRow,
  Value,
  ValueBox,
  ValueSmall,
} from './PersonalData.style-elements';

// Locales
const {
  personalData: { title, captions },
} = reportLocales;

const PersonalData: React.FC = () => {
  const {
    report: {
      basicInfo: { status },
    },
  } = useReportContext();

  if (!isSuccessState(status))
    return (
      <FsDefaultFallbackComponent
        status={status}
        data-test="default-fallback-component"
        withMargin={false}
      />
    );

  return (
    <Fade in={isSuccessState(status)} timeout={1000}>
      <FsPaper title={title} data-test="personal-data-component">
        <FsMinWidthScrollBox breakpointDown="sm">
          <DataRow>
            <Caption>{captions.fullName}</Caption>
            <Value>Emilian Siemsia</Value>
          </DataRow>
          <DataRow>
            <Caption>{captions.dateOfBirth}</Caption>
            <ValueBox>
              <Value>18.03.1984</Value>
              <ValueSmall>37 years old</ValueSmall>
            </ValueBox>
          </DataRow>
          <DataRow>
            <Caption>{captions.gender}</Caption>
            <Value>Male</Value>
          </DataRow>
          <DataRow>
            <Caption>{captions.maidenName}</Caption>
            <Value>Lorem ipsum</Value>
          </DataRow>
          <DataRow>
            <Caption>{captions.phoneNumbers}</Caption>
            <ValueBox>
              <Value>939 399 333</Value>
              <Value>939 399 333</Value>
            </ValueBox>
          </DataRow>
          <DataRow>
            <Caption>{captions.emailAddress}</Caption>
            <ValueBox>
              <Value>lorem.ipsum@lorem.com</Value>
              <Value>lorem.ipsum@lorem.com</Value>
            </ValueBox>
          </DataRow>
          <DataRow>
            <Caption>{captions.niNumber}</Caption>
            <Value>939 399 331</Value>
          </DataRow>
          <DataRow>
            <Caption>{captions.passportNumber}</Caption>
            <Value>939 399 331</Value>
          </DataRow>
          <DataRow isLast>
            <Caption>{captions.drivingLicenceNumber}</Caption>
            <Value>939 399 331</Value>
          </DataRow>
        </FsMinWidthScrollBox>
      </FsPaper>
    </Fade>
  );
};

export default observer(PersonalData);
